import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";

export default function ReelPlayer({ src, srcWebm, poster, label, className, testId, fit = "cover" }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    const v = ref.current;
    if (!v) return undefined;
    v.muted = true;
    const p = v.play();
    if (p && typeof p.catch === "function") p.catch(() => setPlaying(false));
    return () => {
      v.pause();
    };
  }, []);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <div className={`relative ${fit === "contain" ? "bg-black" : ""} ${className || ""}`} data-testid={testId}>
      <video
        ref={ref}
        poster={poster}
        muted
        loop
        playsInline
        preload="metadata"
        className={`h-full w-full ${fit === "contain" ? "object-contain" : "object-cover"}`}
        aria-label={label}
      >
        <source src={src} type="video/mp4" />
        {srcWebm && <source src={srcWebm} type="video/webm" />}
      </video>
      <button
        type="button"
        onClick={toggle}
        aria-label={playing ? "Pause video" : "Play video"}
        data-testid={`${testId}-toggle-button`}
        className="absolute bottom-3 right-3 z-10 rounded-full border border-white/25 bg-ink/70 p-2.5 text-white backdrop-blur transition-colors duration-200 hover:bg-ink/90"
      >
        {playing ? <Pause className="h-4 w-4" aria-hidden /> : <Play className="h-4 w-4" aria-hidden />}
      </button>
    </div>
  );
}
